import {
  buildNodeLookupFromUploadedNodes,
  resolveErrorNodeName,
} from "./ContextImportValidationResult";

const CSV_COLUMNS = [
  "#",
  "Node ID",
  "Node Name",
  "Key",
  "Error Code",
  "Error Message",
];

function formatReportTimestamp(date = new Date()) {
  const pad = (n) => String(n).padStart(2, "0");
  return (
    `${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}-` +
    `${pad(date.getHours())}${pad(date.getMinutes())}`
  );
}

export function buildFailureReportFilename(originalFileName, date = new Date()) {
  const base = String(originalFileName ?? "import")
    .replace(/\.(json|txt|csv)$/i, "")
    .replace(/\.+/g, ".")
    .replace(/\.$/, "");
  return `${base}_failure-report_${formatReportTimestamp(date)}.csv`;
}

export function escapeCsvField(value) {
  if (value == null) {
    return "";
  }
  const str = String(value);
  if (/[",\r\n]/.test(str)) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function generateFailureReportCsv(validationResult) {
  const nodeLookup = buildNodeLookupFromUploadedNodes(
    validationResult.uploadedNodes ?? []
  );
  const rows = [CSV_COLUMNS.map(escapeCsvField).join(",")];

  (validationResult.errors ?? []).forEach((error, index) => {
    const row = [
      index + 1,
      error.nodeId ?? "-",
      resolveErrorNodeName(error, nodeLookup),
      error.field ?? "",
      error.code ?? "",
      error.message ?? "",
    ];
    rows.push(row.map(escapeCsvField).join(","));
  });

  return `\uFEFF${rows.join("\r\n")}\r\n`;
}

export function downloadFailureReportCsv(validationResult) {
  const csv = generateFailureReportCsv(validationResult);
  const filename = buildFailureReportFilename(validationResult.fileName);
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  URL.revokeObjectURL(url);
}

export { CSV_COLUMNS };
